module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selection) ? _c('div', {
    staticClass: "search-tabs"
  }, _vm._l((_vm.selection), function(s) {
    return _c('button', {
      staticClass: "search-tab",
      class: {
        'active-type': s.label === _vm.selected.label
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setNewTab(s)
        }
      }
    }, [_vm._v("\n    " + _vm._s(s.label) + " (" + _vm._s(s.numberOfResults) + ")\n  ")])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27dd26b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/search/SearchTabs.vue
// module id = 773
// module chunks = 0